const translate = {
  translations: [],
  setTranslations(translations) {
    this.translations = JSON.parse(translations);
  },
  get(key, replace) {
    let translation = (this.translations[key]) ? this.translations[key] : key;
    if (replace) {
      Object.keys(replace).forEach((k) => {
        translation = translation.replace(`:${k}`, replace[k]);
      });
    }
    return translation;
  },
  plural(key, count, replace) {
    const raw = (this.translations[key]) ? this.translations[key] : key;
    const parts = raw.split('|');
    let translation = count === 1 ? parts[0] : (parts[1] ?? parts[0]);
    if (replace) {
      Object.keys(replace).forEach((k) => {
        translation = translation.replace(`:${k}`, replace[k]);
      });
    }
    return translation;
  },
};

export default translate;
